import * as Sentry from '@sentry/react';
import assert from 'assert';
import eserf from '../../util/eserf.js';
import xdate from '../../util/date.js';
import config_ext from '../config_ext.js';

let E = {};
export default E;
let app_name = 'front_app_'+config_ext.stage;
let is_test = process.env.IS_TEST;
let inited, is_perf;

let os_hostname = ()=>{
  if (typeof location !== 'undefined')
    return location.hostname;
  return '';
};

let is_localhost = os_hostname()=='localhost';
E.init = ()=>{
  if (inited)
  {
    if (import.meta.hot)
      return void console.warn('sentry already inited');
    assert(0, 'sentry already inited');
  }
  inited = true;
  if (is_test || config_ext.is_local || is_localhost)
    return;
  let ver = config_ext.ver;
  console.log('sentry init', app_name, ver);
  Sentry.init({
    dsn: config_ext.sentry.front.dsn,
    integrations: [Sentry.browserTracingIntegration()],
    release: ver,
    serverName: os_hostname(),
    environment: config_ext.stage,
    tracesSampleRate: is_perf ? 1.0 : undefined,
  });
  eserf.on_exit((msg, stack)=>{
    E.error(msg, stack);
    
    Sentry.flush(2000).then(()=>{}).catch(()=>{});
  });
  let ts = new Date();
  let err_cache = JSON.parse(localStorage.getItem('err_cache'))||{};
  Object.entries(err_cache).forEach(([message, error_ts])=>{
    if (ts.getTime() - new Date(error_ts).getTime() > 1*xdate.MS_DAY)
      delete err_cache[message];
  });
  localStorage.setItem('err_cache', JSON.stringify(err_cache));
  E.consent_grant();
};

E.error = (id, ...args)=>{
  let msg = [id, ...args].join('\n');
  let ts = new Date();
  
  let err_cache = JSON.parse(localStorage.getItem('err_cache')) || {};
  let prev_ts = new Date(err_cache[id]);
  let time_delta = ts.getTime() - prev_ts.getTime();
  if (err_cache[id] && time_delta <= 1*xdate.MS_DAY)
    return;
  if (is_test || config_ext.is_local || process.env.IS_LOCAL || is_localhost)
    return;
  Sentry.withScope(function(scope){
    Sentry.captureException(new Error(msg));
  });
  err_cache[id] = ts.toISOString();
  localStorage.setItem('err_cache', JSON.stringify(err_cache));
};


E.error_once = E.error;

export let set_tag = E.set_tag = (key, v)=>{
  if (is_test || config_ext.is_local || is_localhost)
    return;
  let clarity = window.clarity||(()=>{});
  clarity('set', key, v);
};

export let event = E.event = (event_id, cat, lbl, v)=>{
  if (is_test || config_ext.is_local || is_localhost)
    return;
  let clarity = window.clarity||(()=>{});
  let gtag = window.gtag||(()=>{});
  clarity('set', event_id, v||1);
  gtag('event', event_id,
    {event_category: cat||'main', event_label: lbl||event_id, value: v}
  );
};

E.set_id = (user_id, org_id)=>{
  if (is_test || config_ext.is_local || is_localhost)
    return;
  let clarity = window.clarity||(()=>{});
  let gtag = window.gtag||(()=>{});
  let is_add_tag;
  clarity('identify', user_id);
  if (is_add_tag)
  {
    E.set_tag('set', 'user_id', user_id);
    E.set_tag('set', 'org_id', org_id);
  }
  gtag('config', config_ext.google.analytic_id, {user_id: user_id});
  let scope = Sentry.getCurrentScope();
  scope.setUser({user_id});
};

E.consent_deny = ()=>{
  if (is_test || config_ext.is_local || is_localhost)
    return;
  let gtag = window.gtag||(()=>{});
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied'
  });
  let clarity = window.clarity||(()=>{});
  clarity('consentv2', {ad_Storage: 'denied', analytics_Storage: 'denied'});
};

E.consent_grant = ()=>{
  if (is_test || config_ext.is_local || is_localhost)
    return;
  let gtag = window.gtag||(()=>{});
  gtag('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted'
  });
  let clarity = window.clarity||(()=>{});
  clarity('consentv2', {ad_Storage: 'granted', analytics_Storage: 'granted'});
};

E.conv_purchase = (value='1.0')=>{
  if (is_test || config_ext.is_local || is_localhost)
    return;
  let gtag = window.gtag||(()=>{});
  
  let aw_purchase_id = 'AW-16638494034/ZnNCCKKxosEZENKK7f09';
  gtag('event', 'conversion', {
    send_to: aw_purchase_id,
    value,
    currency: 'USD',
    transaction_id: '',
  });
};